// extracted by mini-css-extract-plugin
export default {"dragElement":"draggable-ingredient_dragElement__Yflya"};